export default __webpack_public_path__ + "static/media/bean-character.91226f90.png";